import { globalCountryDetailsDictionary } from "@core/global/global-country-details";

export const getCountryUsingUrl = () => {
  let url = window.location.href;
  let country = "";
  for (let property in globalCountryDetailsDictionary) {
    if (url.includes(globalCountryDetailsDictionary[property].countryPathName)) {
      country = globalCountryDetailsDictionary[property].country_small;
      break;
    }
  }
  return country;
};

export const timeFrameYearly = 730;
export const timeFrameQuaterly = 270;
